import { render, staticRenderFns } from "./chose.vue?vue&type=template&id=c602f0c4&scoped=true"
import script from "./chose.vue?vue&type=script&lang=js"
export * from "./chose.vue?vue&type=script&lang=js"
import style0 from "./chose.vue?vue&type=style&index=0&id=c602f0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c602f0c4",
  null
  
)

export default component.exports